module.exports = __webpack_public_path__ + "img/c3_m.8fda6ca3.png";